import * as React from 'react';
import TextContainer from '../components/text-container';
import { TImprovedContentMarketing } from '../../../../shared/types/contentMarketing';
import VideoOrImage from '../components/video-or-image';

type TVerticalContentMarketingBlock = {
    contentMarketing: TImprovedContentMarketing;
    isMultipleAds: boolean;
    noPadding?: boolean;
    hasImageRadius?: boolean;
};

const VerticalBlock = ({
    contentMarketing,
    isMultipleAds,
    noPadding,
    hasImageRadius,
}: TVerticalContentMarketingBlock) => {
    return (
        <div data-testid={'cm-vertical-block'} className={'flex flex-col'}>
            <VideoOrImage
                hasImageRadius={hasImageRadius}
                alt="Annonsebilde"
                contentMarketing={contentMarketing}
                isMultipleAds={isMultipleAds}
            />
            <div
                className={`py-16 ${noPadding ? '' : 'px-16'} ${
                    contentMarketing?.videoUrl ? 'relative' : ''
                }`}
            >
                <TextContainer
                    smallText={isMultipleAds}
                    disableTextBalancer={isMultipleAds}
                    contentMarketing={contentMarketing}
                />
            </div>
        </div>
    );
};

export default VerticalBlock;
